// ---------------------------------------------------------------------------
// Person name validation, shared by every "full name" field in the admin
// portal (org owner invite, member invite). Letters, spaces, hyphens,
// apostrophes, and periods only — no digits or other symbols — matching the
// backend's personNameField() so a value the browser accepts is never
// rejected by the API.
// ---------------------------------------------------------------------------
export const NAME_PATTERN_SOURCE = "[\\p{L}][\\p{L}'.\\- ]*";
const NAME_PATTERN = new RegExp(`^${NAME_PATTERN_SOURCE}$`, 'u');

export const NAME_INVALID_MESSAGE =
  'Full name can only contain letters, spaces, hyphens, apostrophes, and periods.';

export function isValidName(value) {
  return NAME_PATTERN.test(value.trim());
}
